<template>
  <div class="login">
    {{userA}}
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      userA: ''
    }
  },
  computed: {
  },
  destroyed () {
  },
  created () {
    this.userA = window.navigator.userAgent.toLowerCase()
    window.localStorage.removeItem('taopenId')
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/clearToken.vue